module.exports = __webpack_public_path__ + "static/img/net.04751f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/net.jpg
// module id = HXqo
// module chunks = 1